<div id="international-players" class="watermark py-5">
  <div class="container-fluid px-lg-5">
    <div class="row">
      <div class="col-12">
        <h2 class="title text-center mb-5">International Players</h2>

        <div class="row justify-content-center">
          <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-4" *ngFor="let player of players">
            <div 
              class="card shadow-sm border-0 h-100 player-card" 
              [class.has-details]="player.details"
              (click)="openDetails(player)">
              <div class="img-wrapper">
                <img [src]="player.image" class="card-img-top player-img" [alt]="player.name">
              </div>
              <div class="card-body text-center">
                <h5 class="card-title fw-bold mb-2">{{ player.name }}</h5>
                <p class="card-text text-muted small mb-2">International Player, {{ player.sport }}</p>
                <button 
                  *ngIf="player.details" 
                  type="button" 
                  class="btn btn-sm btn-details-green rounded-pill px-3 py-1 mt-1">
                  View Details
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <!-- Detailed Profile Modal -->
  <div class="modal-backdrop-custom" *ngIf="selectedPlayer" (click)="closeDetails()"></div>

  <div class="details-modal-dialog" *ngIf="selectedPlayer && selectedPlayer.details">
    <div class="details-modal-content card shadow-lg border-0">
      
      <!-- Modal Header -->
      <div class="modal-header-green d-flex justify-content-between align-items-center">
        <h4 class="mb-0 fw-bold fs-5 text-white">
          International Player Profile - {{ selectedPlayer.name }}
        </h4>
        <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="closeDetails()"></button>
      </div>

      <!-- Modal Body -->
      <div class="card-body p-4">
        
        <!-- Player Info Header -->
        <div class="d-flex flex-column flex-sm-row align-items-center gap-3 mb-4 pb-3 border-bottom">
          <img [src]="selectedPlayer.image" [alt]="selectedPlayer.name" class="rounded shadow-sm" style="width: 90px; height: 110px; object-fit: contain; background: #f8fafc; border: 1px solid #e2e8f0; padding: 4px;">
          <div class="text-center text-sm-start">
            <h3 class="fw-bold mb-1" style="color: var(--primary, #1c5c3e);">{{ selectedPlayer.name }}</h3>
            <p class="text-muted mb-1">
              <strong>Game/ Event:</strong> {{ selectedPlayer.sport }}
              <span class="mx-2">|</span>
              <strong>Country Represented:</strong> {{ selectedPlayer.country || 'India' }}
            </p>
            <p *ngIf="selectedPlayer.details.award" class="mb-0 fw-bold" style="color: #d97706;">
              <i class="fa-solid fa-award me-1"></i> Received Award: {{ selectedPlayer.details.award }}
            </p>
          </div>
        </div>

        <!-- Summary Totals -->
        <div class="row g-2 mb-4 text-center">
          <div class="col">
            <div class="stat-box">
              <div class="stat-val">{{ selectedPlayer.details.totalTournaments }}</div>
              <div class="stat-lbl">Tournaments</div>
            </div>
          </div>
          <div class="col">
            <div class="stat-box">
              <div class="stat-val" style="color: #d97706;">{{ selectedPlayer.details.gold }}</div>
              <div class="stat-lbl">Gold</div>
            </div>
          </div>
          <div class="col">
            <div class="stat-box">
              <div class="stat-val" style="color: #64748b;">{{ selectedPlayer.details.silver }}</div>
              <div class="stat-lbl">Silver</div>
            </div>
          </div>
          <div class="col">
            <div class="stat-box">
              <div class="stat-val" style="color: #b45309;">{{ selectedPlayer.details.bronze }}</div>
              <div class="stat-lbl">Bronze</div>
            </div>
          </div>
          <div class="col">
            <div class="stat-box">
              <div class="stat-val" style="color: var(--primary, #1c5c3e);">{{ selectedPlayer.details.participation }}</div>
              <div class="stat-lbl">Participation</div>
            </div>
          </div>
        </div>

        <!-- Tournaments Table -->
        <h5 class="fw-bold mb-3" style="color: var(--primary, #1c5c3e);">Tournaments Record</h5>
        <div class="table-responsive">
          <table class="tournaments-table table align-middle mb-0">
            <thead>
              <tr>
                <th class="text-center" style="width: 50px;">No.</th>
                <th>Tournament Date</th>
                <th class="text-center">Year</th>
                <th>Venue</th>
                <th>Level / Competition</th>
                <th class="text-center">Achievements / Result</th>
                <th *ngIf="selectedPlayer.details.tournaments[0]?.schoolCollege" class="text-center">School/College</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let t of selectedPlayer.details.tournaments">
                <td class="text-center fw-bold text-muted">{{ t.no }}</td>
                <td>{{ t.date }}</td>
                <td class="text-center">{{ t.year }}</td>
                <td>{{ t.venue }}</td>
                <td class="fw-semibold">{{ t.level }}</td>
                <td class="text-center fw-bold" style="color: var(--primary, #1c5c3e);">{{ t.achievement }}</td>
                <td *ngIf="selectedPlayer.details.tournaments[0]?.schoolCollege" class="text-center text-capitalize">{{ t.schoolCollege }}</td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>

      <!-- Modal Footer -->
      <div class="card-footer bg-light text-end p-3 border-0">
        <button type="button" class="btn-close-modal" (click)="closeDetails()">Close</button>
      </div>

    </div>
  </div>

</div>
